import { Editor } from '@tiptap/react';
import ddt from '@wix/da-ddt';

export const autoScroll = (
  distanceFromBottom: number,
  distanceToScroll: number,
  editor: Editor,
  scrollContainer: HTMLElement | null | undefined
) => {
  const { selection } = editor.state;

  // Dont scroll unless we are typing
  if (!selection.empty) {
    return;
  }

  const isThatShitBrowserSafari =
    'WebkitAppearance' in document.documentElement.style &&
    !/Chrome/.test(navigator.userAgent);

  if (scrollContainer) {
    // Container scrolling
    const viewportCoords = editor.view.coordsAtPos(selection.from);
    const scrollContainerRect = scrollContainer.getBoundingClientRect();
    const containerOffset = scrollContainerRect.top;
    const absoluteOffset =
      scrollContainer.scrollTop +
      (viewportCoords.top - scrollContainerRect.top) -
      window.scrollY;
    const containerRect = scrollContainer.getBoundingClientRect();

    ddt.log('editorautoscroller', 'Auto-Calc', {
      viewportCoords,
      absoluteOffset,
      containerRect,
      distanceFromBottom,
      scrollContainer,
      scTop: scrollContainer.scrollTop,
      win: window.scrollY,
      chk:
        viewportCoords.bottom - containerOffset >=
        containerRect.height - distanceFromBottom,
      scrollContainerRect,
    });
    if (
      viewportCoords.bottom - containerOffset >=
      containerRect.height - distanceFromBottom
    ) {
      const elementBottomRelativeToContainer =
        viewportCoords.top - scrollContainerRect.top;
      ddt.log('editorautoscroller', 'Auto-Scrolled');
      if (isThatShitBrowserSafari) {
        scrollContainer.scrollTo({
          top:
            elementBottomRelativeToContainer -
            scrollContainer.clientHeight +
            scrollContainer.scrollTop +
            distanceToScroll,
          left: scrollContainer.scrollLeft,
        });
      } else {
        scrollContainer.scrollTo({
          behavior: 'smooth',
          top:
            elementBottomRelativeToContainer -
            scrollContainer.clientHeight +
            scrollContainer.scrollTop +
            distanceToScroll,
          left: scrollContainer.scrollLeft,
        });
      }
    }
  } else {
    // Window scrolling
    const viewportCoords = editor.view.coordsAtPos(selection.from);
    const absoluteOffset = window.scrollY + viewportCoords.top;
    ddt.log('editorautoscroller', 'Auto-Scrolled', {
      viewportCoords,
      absoluteOffset,
      height: visualViewport?.height,
      distanceFromBottom,
    });
    if (
      viewportCoords.bottom >=
      (visualViewport?.height ?? 0) - distanceFromBottom
    ) {
      if (isThatShitBrowserSafari) {
        window.scrollTo({
          top:
            absoluteOffset - (visualViewport?.height ?? 0) + distanceToScroll,
          left: window.scrollX,
        });
      } else {
        window.scrollTo({
          top:
            absoluteOffset - (visualViewport?.height ?? 0) + distanceToScroll,
          left: window.scrollX,
          behavior: 'smooth',
        });
      }
    }
  }
};
